module.exports = __webpack_public_path__ + "15f6d675a3853e2350cc03a6deb8bd41.MP3";